<template>
  <el-card>
    <div>
      <el-input style="width:150px" v-model="title" aria-placeholder="内容"></el-input>
      <el-button @click="searchname()">搜索</el-button>
      <el-button type="primary" @click="goadd()">新建公告</el-button>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="公告简介"></el-table-column>
        <el-table-column prop="actionStartTime" label="开始公布时间"></el-table-column>
        <el-table-column prop="actionEndTime" label="结束时间"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 'YXJ'">
              已下架
            </div>
            <div v-if="scope.row.status == 'GSZ'">
              公示中
            </div>
            <div v-if="scope.row.status == 'YJS'">
              已结束
            </div>
            <div v-if="scope.row.status == 'WKS'">
              未开始
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button @click="deletethis(scope.row)" type="text" size="small">删除</el-button>
            <el-button v-if="scope.row.status == 'YXJ'" @click="downline(scope.row)" type="text" size="small">上线</el-button>
            <el-button v-else-if="scope.row.status == 'GSZ'" @click="downline(scope.row)" type="text" size="small">下线</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="limit"
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      total: 0,
      page: 1,
      limit: 20,
      title: "",
      tableData: []
    };
  },
  methods: {
    getnoticList: async function() {
      var title = this.title;
      var res = await this.$http.get(
        `/v1/notice/list?title=${title}&page=${this.page}`
      );
      var { code, message, data, total } = res.data;
      if (code == 0) {
        this.total = total;
        this.tableData = data;
      }
    },
    goadd: function() {
      this.$router.push("/noticeadd");
    },
    deletethis: async function(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.get(`/v1/notice/delete?id=${id}`);
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getnoticList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //上线/下线
    downline: async function(row) {
      var id = row.id;
      var res = await this.$http.get(`/v1/notice/downline?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("设置成功");
        this.getnoticList();
      } else {
        this.$message.error(message);
      }
    },
    edit: async function(row) {
      var id = row.id;
      this.$router.push({
        path: `/noticeadd`,
        query: {
          id: id
        }
      });
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getnoticList();
    },
    searchname:function () {
      this.page=1;
      this.getnoticList();
    }
  },
  mounted() {
    this.getnoticList();
  },
  watch:{
    tableData: {
      handler(newName, oldName) {
        if (this.total == (this.page - 1) * this.limit && this.total != 0) { //这一行是关键代码，倍数关系
          this.page -= 1
          this.getnoticList()//获取表格数据的方法
          if(this.page==0){
            this.page=1;
          }
        }
      },
      // tableData() {  //注意这个函数的名字必须和你监听data中的属性的名字一样，这样才能当你data中的属性发生变化时，触发这个函数
      //   if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) { //这一行是关键代码，倍数关系
      //     this.currentPage -= 1
      //     this.getTagData()//获取表格数据的方法
      //   }
      // },
      deep:true,
    },

  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/notice-mg/notice.vue